import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ScrollToTop } from './utils/scrollToTop';
import TopBanner from './components/TopBanner/TopBanner';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ComingSoon from './pages/ComingSoon/ComingSoon';
import Home from './pages/Home/Home';
import Products from './pages/Products/Products';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import CartPage from './pages/CartPage/CartPage';
import Checkout from './pages/Checkout/Checkout';
import Lookbook from './pages/Lookbook/Lookbook';
import About from './pages/About/About';
import TrackOrder from './pages/TrackOrder/TrackOrder';
import Blog from './pages/Blog/Blog';
import Contact from './pages/Contact/Contact';
import FAQ from './pages/FAQ/FAQ';
import Shipping from './pages/Shipping/Shipping';
import Returns from './pages/Returns/Returns';
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* This ensures scroll to top on every route change */}
      <div className="App">
        <Toaster position="top-center" toastOptions={{ duration: 3500 }} />
        <TopBanner />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/lookbook" element={<Lookbook />} />
            <Route path="/about" element={<About />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;